import { useCompany } from "../../components/CompanyProvider/CompanyProvider";
import { useLogging } from "../useLogging/useLogging";
import { buildCartItem, sumItemsValue, } from "../../analytics/ecommerce";
/**
 * Fires GA4 ecommerce events to both destinations: gtag directly for GA4, and one
 * dataLayer push for whatever the GTM containers have configured.
 */
export const useEcommerce = () => {
    const { gaEvent, gtmEvent } = useLogging();
    const { culture: { currency }, displayName, } = useCompany();
    const track = (event, ecommerce) => {
        gaEvent(event, ecommerce);
        gtmEvent(event, ecommerce);
    };
    const trackCartItem = (event, input) => {
        const item = buildCartItem(input, displayName);
        track(event, { currency, value: sumItemsValue([item]), items: [item] });
    };
    return { currency, itemBrand: displayName, track, trackCartItem };
};
